export enum OptionType {
  Digital = 'Digital',
  Standard = 'Standard',
}

export enum CognitiveIndex {
  Creating = 0,
  Evaluating = 1,
  Analyzing = 2,
  Applying = 3,
  Understanding = 4,
  Remembering = 5,
}

export enum AffectiveIndex {
  Characterizing = 0,
  Organizing = 1,
  Valuing = 2,
  Responding = 3,
  Receiving = 4,
}

export enum PsychomotorIndex {
  Origination = 0,
  Adaptation = 1,
  ComplexOvertResponse = 2,
  Mechanism = 3,
  GuidedResponse = 4,
  Set = 5,
  Perception = 6,
}

export enum ValueCategoryIndex {
  GodCentered = 0,
  PeopleCentered = 1,
  EnvironmentCentered = 2,
  NationCentered = 3,
}

export enum AffectiveType {
  VALUES = 'values',
  ATTITUDES = 'attitudes',
}
